import { TExperienceFormData } from "@/schema/dashboard-schema/experienceSchema";

export const testimonialDefaultValue = {
  firstName: "",
  lastName: "",
  linkedInUrl: "",
  message: "",
};

export const contactDefaultValue = {
  name: "",
  email: "",
  subject: "",
  message: "",
};

export const sortDefaultValue = {
  sortField: "none" as const,
  sortOrder: "none" as const,
};

export const filterDefaultValue = {
  techs: [] as string[],
  projectRelated: "" as string,
  projectType: "" as string,
  liveDemoLink: "" as string,
};

export const loginDefaultValue = {
  email: "",
  password: "",
};

// DASHBOARD
// HEADER
export const headerDefaultValue = {
  bio: "",
  jobTitle: [
    {
      title: "",
    },
  ],
  image: null,
};

// ABOUT
export const aboutDefaultValue = {
  aboutMe: "",
  aboutMe_ar: "",
  resume_ar: null,
  resume_en: null,
  video: null,
  image: null,
};

// EXPERIENCE
export const experienceDefaultValue: TExperienceFormData = {
  jobTitle: "",
  company: "",
  startDate: new Date(),
  endDate: null,
  icon: null,
  workModel: "Onsite",
  jobType: "Full Time",
  companyLocation: "",
  description: [
    {
      name: "",
    },
  ],
  techs: [
    {
      name: "",
    },
  ],
};

// PROJECTS
export const projectDefaultValue = {
  title: "",
  description: "",
  image: null,
  liveDemoLink: "",
  githubLink: "",
  projectType: "",
  projectRelated: "",
  isFavorite: false,
  techs: [
    {
      name: "",
    },
  ],
};

// SKILLS
export const skillDefaultValue = {
  track: "",
  techSkill: "",
  icon: null,
};



// SETTINGS
// GLOBAL INFO
export const globalInfoDefaultValue = {
  nationality: "",
  email: "",
  phone: "",
  address: "",
  linkedin: "",
  github: "",
  facebook: "",
  codepen: "",
};

// TRACK
export const trackDefaultValue = {
  track: "",
};
